/* override functions api.jquery.js */
Shopify.onItemAdded = function(line_item) {
  if (window.ErideCart && typeof window.ErideCart.refresh === 'function') {
    window.ErideCart.refresh().then(function () {
      if (typeof window.ErideCart.open === 'function') window.ErideCart.open();
    });
    return;
  }
  Shopify.getCart();
};

Shopify.onCartUpdate = function(cart) {
  Shopify.cartUpdateInfo(cart, '.single-cart-item-loop');
};

Shopify.onError = function(XMLHttpRequest, textStatus) {
  var data;
  try {
    data = JSON.parse(XMLHttpRequest.responseText);
  } catch (e) {
    data = {};
  }
  var str;
  if (data.message) {
    str = data.description || data.message;
  } else if (typeof Shopify.fullMessagesFromErrors === 'function') {
    str = 'Error : ' + Shopify.fullMessagesFromErrors(data).join('; ') + '.';
  } else {
    str = 'Unable to add item to cart. Please try again.';
  }
  jQuery('.error_message').text(str);
  if (window.ErideCart) {
    document.dispatchEvent(new CustomEvent('eride:cart-add-error'));
  } else {
    jQuery('#modalAddToCartError').modal('toggle');
  }
  setTimeout(function () {
    jQuery('.shopping__cart').removeClass('shopping__cart__on');
    jQuery('.body__overlay').removeClass('is-visible');
  }, 2000);
}

Shopify.addItem = function(variant_id, quantity, callback) {
  var quantity = quantity || 1;
  var card = document.querySelector('.' + variant_id);
  var payload = { id: variant_id, quantity: quantity };

  if (card) {
    var dealerEx = parseInt(card.getAttribute('data-eride-dealer-ex'), 10);
    var isVehicle = card.getAttribute('data-eride-is-vehicle') === 'true';
    var minQty = parseInt(card.getAttribute('data-eride-min-qty'), 10) || 1;
    if (dealerEx > 0) {
      payload.properties = {
        _pricing_tier: 'dealer',
        _unit_price_ex_vat: (dealerEx / 100).toFixed(2),
        _min_qty: String(minQty)
      };
      if (isVehicle) payload.properties._is_vehicle = 'true';
    }
  }

  var params = {
    type: 'POST',
    url: '/cart/add.js',
    data: JSON.stringify(payload),
    contentType: 'application/json',
    dataType: 'json',
    success: function(line_item) {
      if ((typeof callback) === 'function') {
        callback(line_item);
      }
      else {
        if (typeof Shopify.cartPopap === 'function') Shopify.cartPopap(variant_id);
        Shopify.onItemAdded(line_item);
      }
    },
    error: function(XMLHttpRequest, textStatus) {
      Shopify.onError(XMLHttpRequest, textStatus);
    }
  };
  jQuery.ajax(params);
};

Shopify.addItemFromForm = function(form_id, variant_id,callback) {
    var params = {
      type: 'POST',
      url: '/cart/add.js',
      beforeSend: function(){
        if(form_id == "add-item-qv") {
          jQuery('#' + form_id).find(".addtocartqv").html(jQuery(".quickViewModal_info .button_wait").html());
        }
      },
      data: jQuery('#' + form_id).serialize(),
      dataType: 'json',
      success: function(line_item) {
        if ((typeof callback) === 'function') {
          callback(line_item);
        }
        else if(form_id != "add-item-qv") {
          Shopify.cartPopapForm(variant_id);
        } else {
          jQuery('#' + form_id).find(".addtocartqv").html(jQuery(".quickViewModal_info .button_added").html());
          jQuery('#' + form_id).find(".addtocartqv").addClass("added_in_cart");
          setTimeout(function(){
            jQuery('#' + form_id).find(".addtocartqv").removeClass("added_in_cart");
            jQuery('#' + form_id).find(".addtocartqv").html(jQuery(".quickViewModal_info .button").html());
          }, 2000);
        }
        Shopify.onItemAdded(line_item);
      },
      error: function(XMLHttpRequest, textStatus) {
        if(form_id != "add-item-qv") {
          Shopify.onError(XMLHttpRequest, textStatus);
        } else {
          jQuery('#' + form_id).find(".addtocartqv").html(jQuery(".quickViewModal_info .button_error").html());
          jQuery('#' + form_id).find(".addtocartqv").addClass("error_in_cart");
          setTimeout(function(){
            jQuery('#' + form_id).find(".addtocartqv").removeClass("error_in_cart");
            jQuery('#' + form_id).find(".addtocartqv").html(jQuery(".quickViewModal_info .button").html());
          }, 2000);
        }
      }
    };
    jQuery.ajax(params);
};

/* user functions */

Shopify.addItemFromFormStart = function(form, product_id) {
  Shopify.addItemFromForm(form, product_id);
}

Shopify.cartPopap = function(variant_id) {
  	var image = jQuery('.'+variant_id+':first .popup_cart_image').attr("src");
  	var title = jQuery('.'+variant_id+':first .popup_cart_title').text();
  	jQuery('.popupimage').attr("src",''+image+'');
  	jQuery('.productmsg').text(''+title+'');  
  	jQuery('#modalAddToCart').modal("toggle");
}
Shopify.cartPopapForm = function(variant_id) {
  	var image = jQuery('.product_variant_image').attr("src");
  	var title = jQuery('#popup_cart_title').text();
  	jQuery('.popupimage').attr("src",''+image+'');
	jQuery('.productmsg').text(''+title+'');
	jQuery('#modalAddToCart').modal("toggle");
}

Shopify.cartUpdateInfo = function(cart, cart_cell_id) {
  var formatMoney = "<span class='money'>${{amount}}</span>";
  if ((typeof cart_cell_id) === 'string') {
    var cart_cell = jQuery(cart_cell_id);
    if (cart_cell.length) {

      cart_cell.empty();

  
      jQuery.each(cart, function(key, value) {
        if (key === 'items') {
          
          if (value.length == 1) {
            jQuery(".single-product-cart, .item-single-item-count").css({"display": "block"});
            jQuery(".cart-empty-title, .item-multiple-item-count").css({"display": "none"});
            
            var table = jQuery(cart_cell_id);
            jQuery.each(value, function(i, item) {
              if(i > 19){
                  return false;
              }
              jQuery('<li class="single-shopping-cart"><div class="shopping-cart-img"><a href="' + item.url + '"><img src="' + item.image + '" alt="" style="width: 90px;"></a><div class="item-close"><a href="javascript:void(0);" onclick="Shopify.removeItem(\'' + item.key + '\')"><i class="sli sli-close"></i></a></div></div><div class="shopping-cart-title"><h4><a href="' + item.url + '">' + item.title + '</a></h4><span>' + item.quantity + ' x ' + Shopify.formatMoney(item.price, formatMoney) + '</span></div></li>').appendTo(table);
            });
          }			
          else if (value.length) {
            jQuery(".single-product-cart, .item-multiple-item-count").css({"display": "block"});
            jQuery(".cart-empty-title,  .item-single-item-count").css({"display": "none"});
            
            var table = jQuery(cart_cell_id);
            jQuery.each(value, function(i, item) {
              if(i > 19){
                  return false;
              }
              jQuery('<li class="single-shopping-cart"><div class="shopping-cart-img"><a href="' + item.url + '"><img src="' + item.image + '" alt="" style="width: 90px;"></a><div class="item-close"><a href="javascript:void(0);" onclick="Shopify.removeItem(\'' + item.key + '\')"><i class="sli sli-close"></i></a></div></div><div class="shopping-cart-title"><h4><a href="' + item.url + '">' + item.title + '</a></h4><span>' + item.quantity + ' x ' + Shopify.formatMoney(item.price, formatMoney) + '</span></div></li>').appendTo(table);
            });
          }
          else {
            jQuery(".single-product-cart, .item-single-item-count").css({"display": "none"});
            jQuery(".cart-empty-title").css({"display": "block"});
          }
        }
      });

      
    }
  }

  changeHtmlValue(".shopping-cart__total", Shopify.formatMoney(cart.total_price, formatMoney));
  changeHtmlValue(".bigcounter", cart.item_count);
}

//Utils
function changeHtmlValue (cell, value) {
  var $cartLinkText = jQuery(cell);
  $cartLinkText.html(value);
};

Shopify.getCart = function(callback) {
  jQuery.getJSON('/cart.js', function(cart) {
    if (typeof callback === 'function') callback(cart);
    Shopify.onCartUpdate(cart);
    if (window.ErideCart && typeof window.ErideCart.render === 'function') {
      window.ErideCart.render(cart);
    }
  });
};

Shopify.removeItem = function(lineKeyOrVariantId) {
  jQuery.getJSON('/cart.js', function(cart) {
    var line = null;
    jQuery.each(cart.items, function(_, item) {
      if (String(item.key) === String(lineKeyOrVariantId) || String(item.variant_id) === String(lineKeyOrVariantId)) {
        line = item;
        return false;
      }
    });
    if (!line) return;
    jQuery.ajax({
      type: 'POST',
      url: '/cart/change.js',
      data: JSON.stringify({ id: line.key, quantity: 0 }),
      contentType: 'application/json',
      dataType: 'json',
      success: function(updated) {
        Shopify.onCartUpdate(updated);
        if (window.ErideCart && typeof window.ErideCart.render === 'function') {
          window.ErideCart.render(updated);
        }
      }
    });
  });
};